import { urlFor } from '@lib/sanity'
import Image from 'next/image'

import styles from './Hero.module.scss'

export default function Hero({ image, title }) {
  return (
    <div className={styles.wrapper} data-theme="light">
      <Image
        src={urlFor(image.asset)
          .crop('entropy')
          .fit('crop')
          .width(1000)
          .quality(100)
          .format('webp')
          .url()}
        alt={title}
        priority={true}
        fill
      />
    </div>
  )
}
